/* ============================================================
   MARIEVA — JavaScript de Melhorias Visuais
   Arquivo: assets/marieva-enhancements.js
   ============================================================ */

(function() {
  'use strict';

  /* ----------------------------------------------------------
     1. ANIMAÇÕES DE ENTRADA AO SCROLL
     Elementos com classe .marieva-animate aparecem suavemente
     ---------------------------------------------------------- */
  function initScrollAnimations() {
    var elements = document.querySelectorAll('.marieva-animate');
    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback: mostrar tudo se não suportar
      elements.forEach(function(el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -40px 0px'
    });

    elements.forEach(function(el) {
      observer.observe(el);
    });
  }

  /* ----------------------------------------------------------
     2. HEADER TRANSPARENTE → SÓLIDO AO SCROLL
     Adiciona classe quando o utilizador rola a página
     ---------------------------------------------------------- */
  function initHeaderScroll() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;

    var scrollThreshold = 50;
    var ticking = false;

    function updateHeader() {
      if (window.scrollY > scrollThreshold) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });
  }

  /* ----------------------------------------------------------
     3. LAZY LOADING MELHORADO PARA IMAGENS
     Adiciona transição suave quando imagens carregam
     ---------------------------------------------------------- */
  function initImageTransitions() {
    var images = document.querySelectorAll('.card__media img, .collection-list__item img');

    images.forEach(function(img) {
      if (img.complete) {
        img.style.opacity = '1';
        return;
      }

      img.style.opacity = '0';
      img.style.transition = 'opacity 0.4s ease';

      img.addEventListener('load', function() {
        this.style.opacity = '1';
      });
    });
  }

  /* ----------------------------------------------------------
     4. SMOOTH SCROLL PARA LINKS INTERNOS
     ---------------------------------------------------------- */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
      anchor.addEventListener('click', function(e) {
        var targetId = this.getAttribute('href');
        if (targetId === '#') return;

        var target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  /* ----------------------------------------------------------
     5. INICIALIZAÇÃO
     ---------------------------------------------------------- */
  function init() {
    initScrollAnimations();
    initHeaderScroll();
    initImageTransitions();
    initSmoothScroll();
  }

  // Executar quando o DOM estiver pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();